<template>
    <div class="col-sm-12 pt-2">
        <span class="card-title">
            {{ $t('team.add_member') }}
        </span>
        <div v-if="$store.state.user.organization" class="col-sm-12 nopads">
            <b-form-group >
                <b-form-input class="col-sm-11"
                              id="email"
                              v-model="email"
                              type="text"
                              size="mb"
                              :placeholder="$t('team.enter_email')"
                />
                <div class="round-btn mt-2"
                     @click.stop="addMember">
                    <i class="fa fa-plus"/>
                </div>
            </b-form-group>
        </div>

        <transition name="fade">
            <member-list
                    :memberList="newList"
                    :canDelete="true"
                    @removeMember="removeMember"/>
        </transition>
    </div>
</template>

<script>
    import MemberList from "./MemberList";
    import FairApi from '../../modules/api'
    export default {
        name: "members",
        components: {MemberList},
        props: {
            team: {
                type: Object,
                default() {
                    return null
                }
            }
        },
        data: function () {
            return {
                email: null,
                newList: [],
            }
        },

        created() {
            if (this.team !== null) {
                this.newList = this.team.members
            }
        },

        methods: {
            addMember: function () {
                if (this.team && this.email) {
                    this.newList = []
                    FairApi.post(FairApi.teamMember(this.team.id, this.email), null, this.success,  this.fail)
                }
            },
            removeMember: function (email) {
                if (this.team && email) {
                    this.newList = []
                    FairApi.delete(FairApi.teamMember(this.team.id, email), this.success,  this.fail)
                }
            },
            success: function (response) {
                this.email = null
                this.newList = response.members
            },
            fail: function (response) {
                if (response.status === 403) {
                    this.$emit('alert', this.$t('team.unauthorized'))
                } else {
                    this.$emit('alert', this.$t('team.not_found'))
                }
            }
        }
    }
</script>

<style scoped>
</style>
